import { RouteRecordRaw } from 'vue-router';
import DefaultLayout from './layouts/DefaultLayout.vue';

export const routes: Array<RouteRecordRaw> = [
  {
    path: '/articles',
    name: 'articles:default',
    component: DefaultLayout,
    children: [
      {
        path: '/articles',
        component: () => import('./views/ArticleList.vue'),
      },
      {
        path: '/articles/why-smart-card-login-isnt-mainstream',
        name: '_20050704',
        component: () => import('./views/_20250704.vue'),
      },
    ],
  },
];

routes.push({
  path: '/articles/:pathMatch(.*)*',
  redirect: '/articles',
});
